// import React from 'react';
// import { Routes, Route, useLocation } from 'react-router-dom';
// import Home from '../components/Home';
// import Contact from '../pages/Contact';
// import About from '../pages/About';
// import Services from '../pages/Services';
// import PopUpForm from '../pages/PopUpForm';

// const AppRoutes = () => {
//   return (
//     <>
//       <PopUpForm showOnLoad={true} /> {/* ✅ Will be shown on all pages */}

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//       </Routes>
//     </>
//   );
// };


// export default AppRoutes;

import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from '../components/Home';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Services from '../pages/Services';
import PopUpForm from '../pages/PopUpForm';

const AppRoutes = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const showPopupPages = ['/', '/about', '/contact'];

    if (showPopupPages.includes(location.pathname)) {
      if (isFirstLoad.current) {
        setShowPopup(true);
        isFirstLoad.current = false;
      } else {
        setShowPopup(false); // reset
        setTimeout(() => setShowPopup(true), 0); 
      }
    } else {
      setShowPopup(false); 
    }
  }, [location.pathname]);

  return (
    <>
      {showPopup && <PopUpForm showOnLoad={true} />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
